import styled from "styled-components"
import {
  CursorPrev,
  CursorNext,
  CursorCrosshairBlack,
} from "../../../shared/Styles/Cursors"

export const ImageBox = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  transition: 0.4s all ease;
`
export const ImageBoxBlur = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  transition: 0.4s all ease;
`

export const ImageWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  ${ImageBoxBlur} {
    opacity: 1;
  }
  &.current {
    ${ImageBoxBlur} {
      &.hide {
        opacity: 0;
      }
    }
  }
`

export const Container = styled.div`
  max-width: 100vw;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 20px;
  .swiper-container {
    width: 100%;
    height: 68vh;
    .swiper-wrapper {
      .swiper-slide {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        perspective: 635px;

        & > div {
          padding: 20px 100px;
          transform-origin: center center;
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 0.2s transform linear;
          perspective: 635px;
          img {
            ${CursorCrosshairBlack}
          }
          &.slide_transition {
            transform: none !important;
          }
          .gatsby-image-wrapper {
            width: 100%;
            height: 100%;
          }
        }
        &.swiper-slide-prev {
          & > div {
            ${CursorPrev}
          }
        }
        &.swiper-slide-next {
          & > div {
            ${CursorNext}
          }
        }
      }
    }
  }
  @media screen and (max-width: 1601px) {
    .swiper-container {
      .swiper-wrapper {
        .swiper-slide {
          & > div {
            padding: 20px 75px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1441px) {
    .swiper-container {
      height: 100%;
      padding: 40px 20px 80px 20px;
      .swiper-wrapper {
        .swiper-slide {
          padding-left: 20px;
          padding-right: 20px;
          & > div {
            padding: 40px 60px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1367px) {
    .swiper-container {
      .swiper-wrapper {
        .swiper-slide {
          & > div {
            padding: 40px 20px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1281px) {
    .swiper-container {
      padding: 40px 20px 60px 20px;
      .swiper-wrapper {
        .swiper-slide {
          padding-left: 20px;
          padding-right: 20px;
          & > div {
            padding: 40px 40px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1153px) {
    .swiper-container {
      height: 70vh;
      padding: 20px;
      .swiper-wrapper {
        .swiper-slide {
          & > div {
            padding: 20px 20px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1025px) {
    padding-left: 0;
    padding-right: 0;
    .swiper-container {
      height: 60vh;
    }
  }
  @media screen and (max-width: 861px) {
    .swiper-container {
      padding: 40px 20px 40px 20px;
      .swiper-wrapper {
        .swiper-slide {
          padding-left: 20px;
          padding-right: 20px;
          & > div {
            padding: 0;
          }
        }
      }
    }
  }
  @media screen and (max-width: 861px) and (orientation: landscape) {
    .swiper-container {
      padding: 0;
    }
  }
  @media screen and (max-width: 601px) {
    padding-left: 0;
    padding-right: 0;
    .swiper-container {
      height: 100%;
      padding: 85px 0px 80px 0px;
      max-width: 400px;
      width: 100%;
      .swiper-wrapper {
        .swiper-slide {
          padding-left: 20px;
          padding-right: 20px;
          &.swiper-slide-active {
            & > div {
              transform: none !important;
            }
          }
        }
      }
    }
  }
`

export const SlideTitle = styled.div`
  font-family: "sharp_grotesksemibold_25", sans-serif;
  font-size: 78.5px;
  line-height: 1;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  margin: 0;
  color: #000;
  white-space: nowrap;
  -webkit-text-stroke: 2px transparent;
  padding: 0 20px;
  position: relative;
  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 60%;
    transform: translateY(-50%);
    left: 0%;
    width: 100%;
    height: 2px;
    background-color: #000;
  }
  @media screen and (max-width: 1601px) {
    font-size: 60px;
  }
  @media screen and (max-width: 1441px) {
    font-size: 50px;
  }
  @media screen and (max-width: 1350px) {
    font-size: 40px;
  }
  @media screen and (max-width: 1153px) {
    font-size: 30px;
  }
  @media screen and (max-width: 374px) {
    font-size: 28px;
  }
`
export const SubSlideTitle = styled.div`
  padding: 0 20px;
  font-family: "sharp_grotesksemibold_25", sans-serif;
  font-size: 36.5px;
  line-height: 1;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  margin: 0;
  color: #000000;
  white-space: nowrap;
  -webkit-text-stroke: 2px transparent;
  @media screen and (max-width: 1441px) {
    font-size: 24px;
  }
  @media screen and (max-width: 1153px) {
    font-size: 14px;
  }
  @media screen and (max-width: 374px) {
    font-size: 12px;
  }
`

export const SlideNumber = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  font-family: "sharp_grotesksemibold_25", sans-serif;
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  text-align: center;
  color: #000000;
  -webkit-text-stroke: 2px transparent;
`

export const TextBox = styled.div`
  position: absolute;
  bottom: 60px;
  left: 0%;
  z-index: 10;
  transition: 0.4s all ease;
  &.active {
    transform: translateY(-60px);
    ${SlideTitle},
    ${SubSlideTitle} {
      color: transparent;
      -webkit-text-stroke: 2px #ffa290;

      &:after {
        background-color: #ffa290;
      }
    }
  }
  @media screen and (max-width: 1350px) {
    font-size: 40px;
    &.active {
      transform: translateY(-30px);
    }
  }
`

export const PaginationBox = styled.div`
  position: absolute;
  z-index: 10;
  bottom: 50px;
  left: 50px;
  display: flex;
  align-items: center;
  @media screen and (max-width: 1441px) {
    left: 40px;
  }
  @media screen and (max-width: 601px) {
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    justify-content: center;
  }
`

export const Pagination = styled.div`
  ${CursorCrosshairBlack}
  span {
    background-color: #fff;
    font-family: "Bebas Kai Regular", sans-serif;
    font-size: 13px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: center;
    color: #000;
    border: none;
    position: relative;
    width: 25px;
    height: auto;
    background: none;
    opacity: 1;
    ${CursorCrosshairBlack}
    &:not(:last-child) {
      margin-right: 35px;
    }
    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 40px;
      height: 40px;
      border-radius: 100%;
      transition: 0.4s all ease;
      opacity: 0;
      border: 2px solid #ffa290;
    }
    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 8px;
      right: -19px;
      height: 1px;
      background-color: #000;
      z-index: 3;
      transition: 0.4s all ease;
      width: 0;
    }
    &.swiper-pagination-bullet-active {
      &:after {
        opacity: 1;
      }
      &:before {
        width: 20px;
      }
    }
  }
  @media screen and (max-width: 1441px) {
    span {
      &:not(:last-child) {
        margin-right: 25px;
      }
    }
  }
  @media screen and (max-width: 861px) {
    span {
      font-size: 10px;
      &:not(:last-child) {
        margin-right: 5px;
      }
      &:after {
        width: 30px;
        height: 30px;
      }
      &:before {
        top: 6px;
        right: -10px;
      }
      &.swiper-pagination-bullet-active {
        &:before {
          width: 15px;
        }
      }
    }
  }
  @media screen and (max-width: 601px) {
    span {
      &:before {
        top: 5px;
        right: -10px;
      }
    }
  }
  @media screen and (max-width: 374px) {
    span {
      width: 20px;
    }
  }
`

export const ActualPage = styled.div`
  font-family: "Bebas Kai Regular", sans-serif;
  font-size: 11px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: 4.2px;
  color: #4e4e4e;
  margin-top: 3px;
  margin-left: 10px;
  padding-left: 50px;
  padding-top: 2px;
  position: relative;
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 7px;
    left: 0;
    width: 40px;
    height: 1px;
    background-color: #000;
  }
  @media screen and (max-width: 861px) {
    font-size: 10px;
    margin-top: 0px;
    padding-left: 30px;
    &:before {
      width: 20px;
    }
  }
  @media screen and (max-width: 601px) {
    display: none;
  }
`

export const HoverTitle = styled.div`
  font-family: "Bebas Kai Regular", sans-serif;
  font-size: 11px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: 4.2px;
  color: #4e4e4e;
  position: absolute;
  white-space: nowrap;
  top: 0px;
  left: 48px;
  padding: 2px;
  background-color: #fff;
  z-index: 2;
  transition: 0.4s all ease;
  opacity: 0;
  &.active {
    opacity: 1;
  }
  @media screen and (max-width: 861px) {
    font-size: 10px;
    left: 28px;
  }
  @media screen and (max-width: 601px) {
    display: none;
  }
`
